import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import {
  buildSentryTracePropagationTargets,
  hydratePortalSentryUserFromStorage,
  initPortalSentry,
} from '@admin-panel/observability';
import { BrowserRouter } from 'react-router';
import { ensureDeviceFingerprint, getDeviceFingerprint } from '@admin-panel/utils';

import Application from './app/Application';

const tracePropagationTargets = buildSentryTracePropagationTargets(
  import.meta.env.VITE_GATEWAY_API_URL,
);

initPortalSentry(tracePropagationTargets);

const AppErrorFallback = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: '#f8fafc',
      color: '#172033',
      textAlign: 'center',
      fontFamily: 'sans-serif',
    }}
  >
    <div>
      <h2 style={{ margin: '0 0 8px', fontSize: 20 }}>Unable to load this page</h2>
      <p style={{ margin: 0, fontSize: 14 }}>
        Please refresh and try again. If the issue continues, share this screen with the Lyskraft
        team.
      </p>
    </div>
  </div>
);

const bootstrap = async () => {
  await ensureDeviceFingerprint();
  Sentry.setTag('device_id', getDeviceFingerprint());
  hydratePortalSentryUserFromStorage();
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
        <BrowserRouter>
          <Application />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );
};

void bootstrap();

window.setTimeout(() => {
  void import('./app/registerFirebaseServiceWorker').then(
    ({ registerVendorFirebaseServiceWorker }) => registerVendorFirebaseServiceWorker(),
  );
}, 0);
